import React from "react";
import {
  AccessTime,
  InfoOutlined,
  LocalShippingOutlined,
  Warehouse,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useCrossDockingDetailContext } from "contexts/CrossDockingDetailContext";

import { localizeDateTimeShort } from "utils/dateFormats";
import OpenInNewTab from "components/Shared/OpenInNewTab";

const CrossDockingBasicDetail = () => {
  const { crossDockingDetail, loadingCrossDocking } =
    useCrossDockingDetailContext();

  return !loadingCrossDocking ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Cross Docking ID"
            subtitle={crossDockingDetail?.crossDockId || "N/A"}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment ID"
            subtitle={
              crossDockingDetail?.shipmentId &&
              typeof crossDockingDetail.shipmentId === "object" ? (
                <OpenInNewTab
                  label={crossDockingDetail.shipmentId.shipmentId}
                  link={`/app/crm/shipment/${crossDockingDetail.shipmentId._id}/detail`}
                />
              ) : (
                crossDockingDetail?.shipmentId || "N/A"
              )
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <Warehouse color="primary" />}
            title="Source Branch"
            subtitle={
              crossDockingDetail?.sourceBranch &&
              typeof crossDockingDetail.sourceBranch === "object" ? (
                <OpenInNewTab
                  label={crossDockingDetail.sourceBranch.name}
                  link={`/app/crm/branch/${crossDockingDetail.sourceBranch._id}/detail`}
                />
              ) : (
                crossDockingDetail?.sourceBranch || "N/A"
              )
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <Warehouse color="primary" />}
            title="Destination Branch"
            subtitle={
              crossDockingDetail?.destinationBranch &&
              typeof crossDockingDetail.destinationBranch === "object" ? (
                <OpenInNewTab
                  label={crossDockingDetail.destinationBranch.name}
                  link={`/app/crm/branch/${crossDockingDetail.destinationBranch._id}/detail`}
                />
              ) : (
                crossDockingDetail?.destinationBranch || "N/A"
              )
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Transfer Time"
            subtitle={localizeDateTimeShort(crossDockingDetail?.transferTime)}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
            subtitle={crossDockingDetail?.status}
          />
        </Grid>
       <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created By"
            subtitle={crossDockingDetail?.createdBy?.name	 || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Created At"
            subtitle={localizeDateTimeShort(
              crossDockingDetail?.createdAt
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="isActive"
          >
            <Status isActive={crossDockingDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default CrossDockingBasicDetail;
